// ============================================
// COVRFLY UX - Sticky Premium v4.3
// Móvil: Aparece 150px antes del sentinel (donde estaba el botón)
// Desktop: Aparece cuando el CTA original desaparece
// Animación Apple-style cubic-bezier
// ============================================
(function () {
  'use strict';

  const SELECTORS = {
    originalBtn: '.product-form__submit',
    originalParent: '.product__add__cart__button',
    oldSticky: '#covrfly-sticky-bottom',
  };

  const IDS = {
    sticky: 'cf-mobile-sticky-bar',
    style: 'cf-sticky-styles',
    sentinel: 'cf-atc-sentinel',
  };

  // OFFSET: Cuántos píxeles ANTES de llegar al sentinel aparece el sticky
  const TRIGGER_OFFSET = 150;

  const MQ_MOBILE = window.matchMedia('(max-width: 768px)');

  // ---------- Cleanup ----------
  document.querySelector(SELECTORS.oldSticky)?.remove();
  
  // Ocultar sticky nativo del tema
  document.querySelector('.product__sticky')?.style.setProperty('display', 'none', 'important');
  document.getElementById(IDS.sticky)?.remove();
  document.getElementById(IDS.style)?.remove();
  document.getElementById(IDS.sentinel)?.remove();

  const originalBtn = document.querySelector(SELECTORS.originalBtn);
  if (!originalBtn) return;

  // Producto con Kickflip — no ocultar el botón original, no mostrar sticky bar
  if (document.querySelector('customize-button')) {
    window.cfPdpDone && window.cfPdpDone('sticky');
    return;
  }

  // ---------- Sentinel ----------
  const originalParent = originalBtn.closest(SELECTORS.originalParent) || originalBtn.parentElement;
  const sentinel = document.createElement('div');
  sentinel.id = IDS.sentinel;
  sentinel.setAttribute('aria-hidden', 'true');
  sentinel.style.cssText = 'height:1px;pointer-events:none;opacity:0;';
  
  if (originalParent) {
    originalParent.appendChild(sentinel);
  }

  // ---------- CSS ----------
  const css = `
    #${IDS.sticky}{
      position: fixed;
      left: 0; right: 0; bottom: 0;
      z-index: 99999;
      background: #fff;
      border-top: 1px solid rgba(0,0,0,0.08);
      box-shadow: 0 -10px 28px rgba(0,0,0,0.12);
      padding: 12px 16px;
      padding-bottom: calc(12px + env(safe-area-inset-bottom, 0px));
      transform: translate3d(0, 110%, 0);
      opacity: 0;
      pointer-events: none;
      transition:
        transform 0.32s cubic-bezier(0.16, 1, 0.3, 1),
        opacity 0.20s ease-out;
      will-change: transform, opacity;
    }

    #${IDS.sticky}.is-visible{
      transform: translate3d(0, 0, 0);
      opacity: 1;
      pointer-events: auto;
    }

    #${IDS.sticky} .cf-cloned-btn{ width: 100%; }

    body.cf-has-sticky{
      padding-bottom: calc(var(--cf-sticky-h, 84px) + env(safe-area-inset-bottom, 0px)) !important;
    }

    @media (min-width: 769px){
      #${IDS.sticky}{ padding: 10px 12px; }
      #${IDS.sticky} .cf-sticky-inner{ max-width: 760px; margin: 0 auto; }
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.id = IDS.style;
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  // ---------- Sticky DOM ----------
  const stickyBar = document.createElement('div');
  stickyBar.id = IDS.sticky;

  const inner = document.createElement('div');
  inner.className = 'cf-sticky-inner';

  const clonedBtn = originalBtn.cloneNode(true);
  clonedBtn.classList.add('cf-cloned-btn');
  clonedBtn.removeAttribute('id');
  clonedBtn.setAttribute('type', 'button');

  clonedBtn.addEventListener('click', (e) => {
    e.preventDefault();
    const ariaDisabled = originalBtn.getAttribute('aria-disabled') === 'true';
    if (originalBtn.disabled || ariaDisabled) return;
    originalBtn.click();
  });

  inner.appendChild(clonedBtn);
  stickyBar.appendChild(inner);
  document.body.appendChild(stickyBar);

  const updateStickyHeight = () => {
    const h = Math.ceil(stickyBar.getBoundingClientRect().height || 84);
    document.documentElement.style.setProperty('--cf-sticky-h', `${h}px`);
  };
  updateStickyHeight();

  const syncButtonState = () => {
    const ariaDisabled = originalBtn.getAttribute('aria-disabled') === 'true';
    clonedBtn.disabled = !!(originalBtn.disabled || ariaDisabled);
    clonedBtn.className = originalBtn.className + ' cf-cloned-btn';
    if (originalBtn.tagName.toLowerCase() === 'button') {
      clonedBtn.innerHTML = originalBtn.innerHTML;
    }
  };

  const btnMO = new MutationObserver(syncButtonState);
  btnMO.observe(originalBtn, { attributes: true, childList: true, subtree: true });
  syncButtonState();

  // ---------- Lógica show/hide ----------
  let shown = false;
  let ticking = false;

  const shouldShowMobile = () => {
    const r = originalBtn.getBoundingClientRect();
    return r.bottom <= 0;
  };

  const shouldShowDesktop = () => {
    const r = originalBtn.getBoundingClientRect();
    return r.bottom <= 0;
  };

  const showSticky = () => {
    if (shown) return;
    stickyBar.classList.add('is-visible');
    document.body.classList.add('cf-has-sticky');
    shown = true;
    updateStickyHeight();
  };

  const hideSticky = () => {
    if (!shown) return;
    stickyBar.classList.remove('is-visible');
    document.body.classList.remove('cf-has-sticky');
    shown = false;
  };

  const evaluate = () => {
    ticking = false;
    updateStickyHeight();

    if (MQ_MOBILE.matches) {
      if (shouldShowMobile()) showSticky();
      else hideSticky();
    } else {
      if (shouldShowDesktop()) showSticky();
      else hideSticky();
    }
  };

  const onScrollOrResize = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(evaluate);
  };

  window.addEventListener('scroll', onScrollOrResize, { passive: true });
  window.addEventListener('resize', onScrollOrResize);

  const onMqChange = () => {
    hideSticky();
    requestAnimationFrame(evaluate);
  };
  try { MQ_MOBILE.addEventListener('change', onMqChange); }
  catch (_) { MQ_MOBILE.addListener(onMqChange); }

  requestAnimationFrame(evaluate);

  console.log('✅ COVRFLY: Sticky Premium v4.3 inicializado');

  // Anti-FOUC v2.0: señal al orquestador
  window.cfPdpDone && window.cfPdpDone('sticky');

})();
